import React, { Component } from "react"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

class PayrollMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.setting_menu}
          toggle={() =>
            this.setState({ setting_menu: !this.state.setting_menu })
          }
        >
          <DropdownToggle
            color="primary"
            className="arrow-none waves-effect waves-light"
          >
            <i className="mdi mdi-pencil-plus ms-1" />
            Actions
          </DropdownToggle>
          <DropdownMenu className="language-switch" end>
            <div className="dropdown-divider" />
            <DropdownItem tag="a" href="#" onClick={this.props.onCreatePayroll}>
              Create Payroll
            </DropdownItem>
            <div className="dropdown-divider" />
            <DropdownItem tag="a" href="#">
              Process
            </DropdownItem>
            <DropdownItem tag="a" href="#">
              Remove
            </DropdownItem>
            <DropdownItem tag="a" href="#">
              Something else here
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    )
  }
}

export default PayrollMenu
